import React from 'react'
import { NavLink, useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Button, Typography } from '@material-ui/core'
import { Translate } from 'react-localize-redux'
import { SubLink } from 'containers'
import useTeamFeature from 'hooks/useTeamFeature'
import LockIconComponent from 'components/UpgradeMembership/LockIconComponent'
import useFeatureAccessGuard from 'hooks/useFeatureAccessGuard'
import TeaserChip from 'components/Teaser/TeaserChip'
import usePermission from 'hooks/usePermission'
import {
  TRAINING_PACKAGES_ROUTE,
  DRILLS_CATEGORIES,
  DRILL_CREATE_ROUTE,
} from 'constants/routes'
import PERMISSIONS from 'constants/permissions'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const useStyles = makeStyles((theme) => ({
  navigation: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 15,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  navList: {
    listStyle: 'none',
    padding: 0,
    display: 'flex',
  },
  navItem: {
    paddingRight: '35px',
  },
  link: {
    color: 'gray',
  },
}))

const Navigation = () => {
  const { teamUuid, seasonId } = useParams()
  const baseRoute = `/team/${teamUuid}/season/${seasonId}`
  const classes = useStyles()

  const canUpdateClub = usePermission(PERMISSIONS.UPDATE_CLUB, 'club')

  const featureGuard = useFeatureAccessGuard()

  const { enabled: hasCreateActivitiesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.create_activities
  )
  const { enabled: hasActivitiesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.activities_enabled
  )
  const { enabled: hasTrainingPackagesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.training_packages_enabled
  )

  return (
    <>
      <nav className={classes.navigation}>
        <ul className={classes.navList}>
          <li className={classes.navItem}>
            <Typography variant="h3" component="h3">
              <Translate id="drills.activities" />
              {!hasActivitiesEnabled && <TeaserChip />}
            </Typography>
          </li>
          <li>
            <NavLink
              to={`${baseRoute}${TRAINING_PACKAGES_ROUTE}`}
              className={classes.link}
            >
              <Typography variant="h3" component="h3">
                <Translate id="navbar.training_packages" />
                {!hasTrainingPackagesEnabled && <TeaserChip />}
              </Typography>
            </NavLink>
          </li>
        </ul>
        <Box display="flex" gridGap={8}>
          {canUpdateClub && (
            <Button
              variant="contained"
              color="primary"
              {...(!hasCreateActivitiesEnabled
                ? {
                    onClick: () => featureGuard(),
                  }
                : {
                    component: SubLink,
                    to: DRILLS_CATEGORIES,
                  })}
              endIcon={
                !hasCreateActivitiesEnabled ? (
                  <LockIconComponent context="primaryButton" />
                ) : null
              }
            >
              <Translate id="drills.manage-categories" />
            </Button>
          )}

          <Button
            variant="contained"
            color="primary"
            {...(!hasCreateActivitiesEnabled
              ? {
                  onClick: () => featureGuard(),
                }
              : {
                  component: SubLink,
                  to: DRILL_CREATE_ROUTE,
                })}
            endIcon={
              !hasCreateActivitiesEnabled ? (
                <LockIconComponent context="primaryButton" />
              ) : null
            }
          >
            <Translate id="drills.create-drill" />
          </Button>
        </Box>
      </nav>
    </>
  )
}

export default Navigation
